module.exports = __webpack_public_path__ + "img/trailer-bg.ec71d9d8.jpeg";